import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class StaticResourcesService {

  endpoint = environment.API_URL + "rest/resources";
  configSubjectLastValue: any;

  public isI18nConfigFetched:boolean = false;

  constructor(
    private http: HttpClient,
  ) {   }

  fetchTheme() {
    return this.http
      .get<any>(
        this.endpoint + "/theme")
      .pipe(
        map(responseData => {
          return responseData.theme;
        })
      )
  }

  fetchConfigs() {
    return this.http
      .get<any>(
        this.endpoint + "/configs")
      .pipe(
        map(responseData => {
          this.configSubjectLastValue = responseData;
          return responseData;
        })
      )
  }

  setFetchedTranslation(value) {
    this.isI18nConfigFetched = value;
  }
}
